/* eslint max-lines: off */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType, modalActionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';
import ManualReassignContainer from './buttons/ManualReassignContainer';
import { ForceValidationDetail, ForceValidationlist } from './buttons/ForceValidation';
import ApplyAndValidate from './buttons/ApplyAndValidate';
import ConnectJies from './buttons/ConnectJies';
import ExportToSap from './buttons/ExportToSap';
import ReverseRepostButton from './buttons/ReverseRepostButton';
import CheckDuplicateDocument from './buttons/DuplicateDocuments';
import SendToWorkflow from './buttons/SendToWorkflow';
import MissingVendor from './buttons/MissingVendor';
import UnlockDocument from './buttons/UnlockDocument';
import Rebatch from './buttons/Rebatch';
import LitigationMail from './buttons/LitigationMail';
import LitigationArchive from './buttons/LitigationArchive';
import AssignDocument from './buttons/AssignDocument';
import DownloadJies from './buttons/DownloadJies';
import SendMail from './buttons/SendMail';
import Reject from './buttons/Reject';
import Approval from './buttons/Approval';
import AssignDocumentLatency from './buttons/AssignDocumentLatency';
import services from 'services';
import RetriveDocFromLitigationPark from './buttons/RetriveDocFromLitigationPark';
import RetriveDocFromDispatcher from './buttons/RetrieveDocFromDispatcher';
import SanityCheck from './buttons/SanityCheck';
import GenerateDEM from './buttons/GenerateDEM';
import ValidateLease from './buttons/ValidateLease';
import UndoValidate from './buttons/UndoValidate';
import ViewPreviousDocuments from './buttons/ViewPreviousDocuments';
import LinkAssetId from './buttons/LinkAssetId';
import ToggleExpander from './buttons/ToggleExpander';
import Glossary from './buttons/Glossary';

interface ToolbarButton {
  action: string;
}

const ToolbarButton = (props: ToolbarButton) => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const { action } = props;
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const isSearchFilterVisible = useSelector(selectors.documents.selectIsSearchFilterVisible);
  const isEditView = utils.documents.isOpenDocumentView();
  switch (action) {
    case actionType.MASSIVE_DOC_TYPE_CHANGE:
      return (
        <CommonButton
          id={actionType.MASSIVE_DOC_TYPE_CHANGE}
          action={() => dispatch(actions.modal.openModal(actionType.MASSIVE_DOC_TYPE_CHANGE))}
          disabled={!utils.user.isActionEnabled(records, actionType.MASSIVE_DOC_TYPE_CHANGE)}
          scope="tertiary"
          value={t('massive-doc-type-change')}
          customIcon="cycle"
        />
      );
    case actionType.SENDMAIL:
      return <SendMail />;
    case actionType.REASSIGN_PRIORITY:
      return (
        <CommonButton
          id={actionType.REASSIGN_PRIORITY}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.REASSIGN_PRIORITY))}
          disabled={!utils.user.isActionEnabled(records, actionType.REASSIGN_PRIORITY)}
          scope="tertiary"
          value={t('reassign-priority')}
          customIcon="revert-flux"
        />
      );
    case actionType.ALLEGA:
      return (
        <CommonButton
          id={actionType.ALLEGA}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.ALLEGA))}
          disabled={!utils.user.isActionEnabled(records, actionType.ALLEGA)}
          scope="tertiary"
          value={t('manage-attachments')}
          customIcon="paperclip"
        />
      );
    case actionType.ASSIGNDOCUMENT:
      return <AssignDocument />;
    case actionType.NOTES:
      return (
        <CommonButton
          id={actionType.NOTES}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.ADD_MEMO))}
          disabled={!utils.user.isActionEnabled(records, actionType.NOTES)}
          scope="tertiary"
          value={t('notes')}
          customIcon="sticky-note"
        />
      );
    case actionType.DELETE_DOCUMENT:
      return (
        <CommonButton
          id={actionType.DELETE_DOCUMENT}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.DELETE_DOCUMENTS))}
          scope="tertiary"
          value={t('delete')}
          customIcon="trash"
          disabled={!utils.user.isActionEnabled(records, actionType.DELETE_DOCUMENT)}
        />
      );
    case actionType.OPEN_WORKFLOW:
      return <SendToWorkflow />;
    case actionType.MISSING_VENDOR:
      return <MissingVendor />;
    case actionType.RETURN_TO_BATCH:
      return <Rebatch />;
    case actionType.LOG:
      return (
        <CommonButton
          id={actionType.LOG}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.LOG))}
          disabled={!utils.user.isActionEnabled(records, actionType.LOG)}
          scope="tertiary"
          value={t('log')}
          customIcon="log"
        />
      );
    case actionType.MANUAL_REASSIGN_DOCUMENTS:
      return (
        <ManualReassignContainer
          disabled={!utils.user.isActionEnabled(records, actionType.MANUAL_REASSIGN_DOCUMENTS)}
          mode={actionType.MANUAL_REASSIGN_DOCUMENTS}
        />
      );

    case actionType.MANUAL_REASSIGN_DOCUMENTS_NO_OCR:
      return (
        <ManualReassignContainer
          disabled={!utils.user.isActionEnabled(records, actionType.MANUAL_REASSIGN_DOCUMENTS_NO_OCR)}
          mode={actionType.MANUAL_REASSIGN_DOCUMENTS_NO_OCR}
        />
      );

    case actionType.MANUAL_REASSIGN_DOCUMENTS_OCR:
      return (
        <ManualReassignContainer
          disabled={!utils.user.isActionEnabled(records, actionType.MANUAL_REASSIGN_DOCUMENTS_OCR)}
          mode={actionType.MANUAL_REASSIGN_DOCUMENTS_OCR}
        />
      );

    case actionType.APPLYRULES:
      return (
        <ApplyAndValidate disabled={!utils.user.isActionEnabled(records, actionType.APPLYRULES)} isValidate={false} />
      );
    case actionType.VALIDATE:
      return <ApplyAndValidate disabled={!utils.user.isActionEnabled(records, actionType.VALIDATE)} isValidate />;
    case 'ActionDocumentForceQC':
      return isEditView ? <ForceValidationDetail /> : <ForceValidationlist />;
    // intereactive export view case
    case actionType.SELF_VALIDATE:
      return (
        <CommonButton
          id={actionType.SELF_VALIDATE}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.SELF_VALIDATE))}
          scope="tertiary"
          value={t('self-validate')}
          disabled={!utils.user.isActionEnabled(records, actionType.SELF_VALIDATE)}
          customIcon="double-check"
        />
      );
    case actionType.SPLIT_FIX:
      return (
        <CommonButton
          id={actionType.SPLIT_FIX}
          action={() => dispatch(actions.modal.openModal(actionType.SPLIT_FIX))}
          disabled={!utils.user.isActionEnabled(records, actionType.SPLIT_FIX)}
          scope="tertiary"
          value={t('split-fix')}
          customIcon="splitFix"
        />
      );
    case actionType.ADDNEWSTORE:
      return (
        <CommonButton
          id={actionType.ADDNEWSTORE}
          disabled={!utils.user.isActionByCompanyActive(actionType.ADDNEWSTORE)}
          value={t('new-store')}
          customIcon="plus"
          scope="tertiary"
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.NEW_STORE))}
        />
      );
    case actionType.SET_RECEIPT_DATE:
      return (
        <CommonButton
          id={actionType.SET_RECEIPT_DATE}
          action={() => dispatch(actions.modal.openModal(actionType.SET_RECEIPT_DATE))}
          scope="tertiary"
          value={t('Set Scan Date')}
          disabled={!utils.user.isActionEnabled(records, actionType.SET_RECEIPT_DATE)}
          customIcon="calendar-alt"
        />
      );
    case actionType.COMPANY_DOC_TYPE:
      return (
        <CommonButton
          id={actionType.COMPANY_DOC_TYPE}
          action={() => {
            dispatch(actions.modal.openModal(modalActionType.documents.COMPANY_DOC_TYPE));
          }}
          scope="tertiary"
          value={t('company-doc-type')}
          disabled={utils.user.isActionEnabled(records, actionType.COMPANY_DOC_TYPE) || records.length < 1}
          customIcon="folder2"
        />
      );
    case actionType.REJECT:
      return <Reject />;
    case actionType.REJECT_PREVIOUS:
      return (
        <CommonButton
          id={actionType.REJECT_PREVIOUS}
          action={() => dispatch(actions.modal.openModal(actionType.REJECT_PREVIOUS))}
          scope="tertiary"
          value={t(actionType.REJECT_PREVIOUS)}
          disabled={!utils.user.isActionEnabled(records, actionType.REJECT_PREVIOUS)}
          customIcon="previous"
        />
      );
    // convalida documenti
    case actionType.CONFIRM:
      return <Approval />;
    case actionType.PARK:
      return (
        <CommonButton
          id={actionType.PARK}
          action={() => dispatch(actions.modal.openModal(actionType.PARK))}
          scope="tertiary"
          value={t('park-document')}
          disabled={!utils.user.isActionEnabled(records, actionType.PARK)}
          customIcon="park"
        />
      );
    case actionType.CLOSEPARK:
      return (
        <CommonButton
          id={actionType.CLOSEPARK}
          action={() => dispatch(actions.modal.openModal(actionType.CLOSEPARK))}
          scope="tertiary"
          value={t('close-park-document')}
          disabled={!utils.user.isActionEnabled(records, actionType.CLOSEPARK)}
          customIcon="radio-play"
        />
      );
    case actionType.LITIGATION_MAIL:
      return <LitigationMail />;
    case actionType.LITIGATION_PARK_MAIL:
      return <LitigationMail isLitigationPark={true} />;
    case actionType.LITIGATION_PRINT:
      return (
        <CommonButton
          id={actionType.LITIGATION_PRINT}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.LITIGATION, { type: 'print' }))}
          customIcon="print"
          scope="tertiary"
          value={t(actionType.LITIGATION_PRINT)}
          disabled={!utils.user.isActionEnabled(records, actionType.LITIGATION_PRINT)}
        />
      );
    case actionType.LITIGATION_PARK_PRINT:
      return (
        <CommonButton
          id={actionType.LITIGATION_PARK_PRINT}
          action={() =>
            dispatch(
              actions.modal.openModal(modalActionType.documents.LITIGATION, { type: 'print', isLitigationPark: true }),
            )
          }
          customIcon="print"
          scope="tertiary"
          value={t(actionType.LITIGATION_PARK_PRINT)}
          disabled={!utils.user.isActionEnabled(records, actionType.LITIGATION_PARK_PRINT)}
        />
      );
    case actionType.LITIGATION_ARCHIVE:
      return <LitigationArchive />;
    case actionType.LITIGATION_PARK_ARCHIVE:
      return <LitigationArchive isLitigationPark={true} />;
    case 'NuovaRicerca':
    case 'NuovaRicercaDocList':
      return (
        <CommonButton
          id="nuova-ricerca"
          scope="tertiary"
          value={t('nuova-ricerca-doc')}
          customIcon="search-void"
          action={async () => {
            await dispatch(actions.documents.setCurrentFilters([]));
            await dispatch(actions.documents.setCurrentPageIndex(0));
            await dispatch(actions.documents.setResetDocumentFilterForm());
            await dispatch(actions.documents.setSelectedTemplateFilter(null));
            dispatch(actions.documents.setDocumentImage(''));
            dispatch(actions.documents.setActiveDocumentId([]));
            dispatch(actions.documents.setDocumentImageId(0));
            await dispatch(actions.documents.setIsSearchFilterVisible(true));
          }}
        />
      );
    case 'RaffinaRicerca':
    case 'RaffinaRicercaDocList':
      return (
        <CommonButton
          id="raffina-ricerca"
          scope="tertiary"
          value={t('raffina-ricerca-doc')}
          disabled={isSearchFilterVisible}
          customIcon="search-plus"
          action={() => {
            dispatch(actions.documents.setIsSearchFilterVisible(true));
            dispatch(actions.documents.setDocumentGridRows([]));
            dispatch(actions.documents.setDocumentImage(''));
            dispatch(actions.documents.setDocumentImageId(0));
            dispatch(actions.documents.setActiveDocumentId([]));
          }}
        />
      );
    case 'SetSubject':
      return (
        <CommonButton
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.SEARCH_SUBJECT))}
          id="set-subject"
          scope="tertiary"
          disabled={!utils.user.isActionEnabled(records, 'SetSubject')}
          value={t('SetSubject')}
          customIcon="change-claim-message"
        />
      );
    case actionType.ASK_INFO:
      return (
        <CommonButton
          id={actionType.ASK_INFO}
          action={() => dispatch(actions.modal.openModal(actionType.ASK_INFO))}
          scope="tertiary"
          value={t('ask_info')}
          disabled={!utils.user.isActionEnabled(records, actionType.ASK_INFO)}
          customIcon="askInfo"
        />
      );
    case actionType.RESPONSE_INFO:
      return (
        <CommonButton
          id={actionType.RESPONSE_INFO}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.RESPONSE_INFO))}
          scope="tertiary"
          value={t('convalidate-info')}
          disabled={!utils.user.isActionEnabled(records, actionType.RESPONSE_INFO)}
          customIcon="fa-check"
        />
      );
    case actionType.CLOSE_LITIGATION:
      return (
        <CommonButton
          id={actionType.CLOSE_LITIGATION}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.CLOSE_LITIGATION))}
          scope="tertiary"
          value={t('close_validation')}
          disabled={!utils.user.isActionEnabled(records, actionType.CLOSE_LITIGATION)}
          customIcon="trash"
        />
      );
    case actionType.DOWNLOAD_JIES:
      return <DownloadJies />;
    case actionType.CONNECT_JIES:
      return <ConnectJies />;
    case actionType.EXPORT_TO_SAP:
      return <ExportToSap />;
    case actionType.REVERSE_REPOST:
      return <ReverseRepostButton disabled={!utils.user.isActionEnabled(records, actionType.REVERSE_REPOST)} />;
    case actionType.CHECK_DUPLICATE_DOCUMENT:
      return <CheckDuplicateDocument />;
    case actionType.DOCUMENT_HISTORY:
      return (
        <CommonButton
          id={actionType.DOCUMENT_HISTORY}
          action={() => dispatch(actions.modal.openModal(modalActionType.documents.DOCUMENT_HISTORY))}
          disabled={!utils.user.isActionEnabled(records, actionType.DOCUMENT_HISTORY)}
          scope="tertiary"
          value={t('document-history-button')}
          customIcon="timer"
        />
      );
    case actionType.UNLOCK_DOCUMENT:
      return <UnlockDocument disabled={!utils.user.isActionEnabled(records, actionType.UNLOCK_DOCUMENT)} />;
    case actionType.ASSIGN_DOCUMENT_LATENCY:
      return <AssignDocumentLatency />;
    case actionType.DOWNLOAD_PDF:
      return (
        <CommonButton
          id={actionType.DOWNLOAD_PDF}
          action={() => {
            dispatch(
              actions.modal.setModal({
                actionType: modalActionType.documents.DOWNLOAD_ARCHIVE_PDF,
                props: {
                  func: async () => {
                    const response = await services.downloadArchivePDF(records.map((row) => Number(row?.protocol)));
                    if (response?.data?.size === 0) {
                      utils.app.notify('warning', t('size-0-zip'));
                      return;
                    }
                    utils.file.downloadFileZip(response.data, 'archived-pdf.zip');
                    dispatch(actions.modal.closeModal());
                  },
                  title: t('download-pdf'),
                  subtitle: t('download-pdf-subtitle'),
                  confirmText: t('continue-download-pdf'),
                },
              }),
            );
          }}
          disabled={!utils.user.isActionEnabled(records, actionType.DOWNLOAD_PDF)}
          scope="tertiary"
          value={t('download-pdf')}
          customIcon="download"
        />
      );
    case actionType.RETRIVE_DOC_FROM_LITIGATION:
      return <RetriveDocFromLitigationPark />;
    case actionType.RETRIEVE_FROM_DOCUMENTS:
      return <RetriveDocFromDispatcher />;
    case actionType.SANITY_CHECK:
      return <SanityCheck />;
    case actionType.GENERATE_DEM:
      return <GenerateDEM />;
    case actionType.LEASE_VALIDATE:
      return <ValidateLease />;
    case actionType.UNDO_VALIDATE:
      return <UndoValidate />;
    case actionType.VIEW_PREVIOUS_DOCUMENTS:
      return <ViewPreviousDocuments />;
    case actionType.LINK_ASSET_ID:
      return <LinkAssetId />;
    case actionType.HIDE_HEADER:
      return <ToggleExpander />;
    case actionType.GLOSSARY:
      return <Glossary />;
    default:
      return <div> {action} not supported</div>;
  }
};

export default ToolbarButton;
